(() => {
  const toast = (message) => {
    const el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(window.hushlyToastTimer);
    window.hushlyToastTimer = setTimeout(() => { el.hidden = true; }, 2800);
  };

  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    if (menu) menu.hidden = open;
  });

  document.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    window.location.assign(url.toString());
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const price = select.selectedOptions[0]?.dataset.price;
      const target = select.closest('[data-product-section]')?.querySelector('[data-product-price]');
      if (price && target) target.textContent = price;
    });
  });

  document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.quick-add-form,.product-form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"],button[name="add"]');
      if (!button || button.disabled) return;
      button.disabled = true;
      try {
        const formData = new FormData(form);
        const selections = [...form.querySelectorAll('[data-bundle-variant]:not(:disabled)')];
        const headers = { Accept: 'application/json' };
        let body = formData;
        if (selections.length) {
          const quantity = Number(formData.get('quantity'));
          if (selections.length !== quantity || selections.some(select => !select.value || select.selectedOptions[0]?.disabled)) throw new Error('Invalid bundle');
          const properties = {};
          for (const [key, value] of formData) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) properties[match[1]] = value;
          }
          const items = [];
          selections.forEach(select => {
            const id = Number(select.value);
            const existing = items.find(item => item.id === id);
            if (existing) existing.quantity++;
            else items.push({ id, quantity: 1, ...(Object.keys(properties).length ? { properties } : {}), ...(formData.get('selling_plan') ? { selling_plan: formData.get('selling_plan') } : {}) });
          });
          headers['Content-Type'] = 'application/json';
          body = JSON.stringify({ items });
        }
        const cartRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers, body });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch(cartRoot + 'cart.js').then((r) => r.json());
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        await window.hushlyCart.refresh(true);
      } catch {
        toast('This item could not be added. Please try again.');
      } finally { button.disabled = false; }
  });

  const routine = document.querySelector('[data-routine]');
  const routineProducts = window.hushlyRoutineCatalog(JSON.parse(document.querySelector('[data-routine-products]')?.textContent || '[]'));
  const metadata = Object.fromEntries(routineProducts.map(p => [p.handle, p.routine]));
  const money = cents => new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100);
  const updateRoutineTotal = () => {
    let total=0, discounted=0;
    routine?.querySelectorAll('[data-routine-slot]').forEach(card=>{
      const p=routineProducts.find(p=>p.id===Number(card.querySelector('[data-routine-product]').value));
      const v=p?.variants.find(v=>v.id===Number(card.querySelector('[data-routine-variant]').value));
      const qty=Number(card.querySelector('[data-routine-quantity]').value);
      if(v?.available){total+=v.price*qty;discounted+=Math.round(v.price*.7)*qty;}
    });
    discounted=total-Math.floor(total*.3+0.000001);
    if(routine){routine.querySelector('[data-routine-add]').disabled = [...routine.querySelectorAll('[data-routine-variant]')].some(s => !s.value || s.selectedOptions[0]?.disabled);routine.querySelector('[data-routine-original]').textContent=money(total);routine.querySelector('[data-routine-total]').textContent=money(discounted);routine.querySelector('[data-routine-saving]').textContent=money(total-discounted);}
  };
  routine?.querySelectorAll('[data-routine-slot]').forEach(card=>{
    const slot=Number(card.dataset.routineSlot), select=card.querySelector('[data-routine-product]');
    const choices=routineProducts.filter(p=>metadata[p.handle]?.slots.includes(slot)&&p.handle!=='sleep-guide-ebook');
    choices.forEach(p=>select.add(new Option(p.title,p.id)));
    const preferred=choices.find(p=>p.handle===['sleep-socks','silk-pillowcase','double-sided-silk-sleeping'][slot]);
    if(preferred)select.value=preferred.id;
    const refresh=()=>{
      const p=choices.find(p=>p.id===Number(select.value));const variants=card.querySelector('[data-routine-variant]');variants.replaceChildren();
      if(p){p.variants.forEach(v=>{const option=new Option(v.title+' · '+money(v.price),v.id);option.disabled=!v.available;variants.add(option);});
        const first=p.variants.find(v=>v.available);if(first)variants.value=first.id;
        const img=card.querySelector('[data-routine-image]');const showImage=()=>{const v=p.variants.find(v=>v.id===Number(variants.value));const fallback=metadata[p.handle].image;const source=v?.featured_image?.src||p.featured_image||(fallback ? document.querySelector('script[src*="routine-metadata.js"]').src.replace(/routine-metadata\.js.*$/,fallback) : '');img.hidden=!source;if(source)img.src=source;img.alt=p.title;};variants.onchange=showImage;showImage();
      }updateRoutineTotal();
    }; select.addEventListener('change',refresh);card.addEventListener('change',updateRoutineTotal);refresh();
  });
  const quiz=document.querySelector('[data-quiz]');
  const typeSelect=quiz?.querySelector('[data-quiz-type]');
  if(typeSelect){[...new Set(routineProducts.map(p=>p.routine.type))].sort().forEach(type=>typeSelect.add(new Option(type,type)));}
  if(quiz&&!routineProducts.length){quiz.querySelector('[type="submit"]').disabled=true;}
  quiz?.querySelector('[data-quiz-build]')?.toggleAttribute('hidden',!routine);
  let quizMatches=[];
  quiz?.querySelector('[data-quiz-form]').addEventListener('submit',event=>{
    event.preventDefault();
    const goal=quiz.querySelector('[data-quiz-goal]').value;
    const type=quiz.querySelector('[data-quiz-type]').value;
    const goals=routineProducts.filter(p=>metadata[p.handle]?.goals.includes(goal));
    const matches=goals.filter(p=>type==='No preference'||metadata[p.handle]?.type===type);
    const sameType=routineProducts.filter(p=>type==='No preference'||p.routine.type===type);quizMatches=matches.length?matches:sameType.length?sameType:goals.length?goals:routineProducts;
    const grid=quiz.querySelector('[data-quiz-grid]');grid.replaceChildren();
    quizMatches.forEach(p=>{const template=quiz.querySelector(`[data-quiz-card="${p.handle}"]`);if(template)grid.append(template.content.cloneNode(true));});
    const message=quiz.querySelector('[data-quiz-message]');message.textContent=matches.length?message.dataset.match:message.dataset.fallback;
    quiz.querySelector('[data-quiz-results]').hidden=false;
    quiz.querySelector('[data-quiz-heading]').focus({preventScroll:true});
  });
  quiz?.querySelectorAll('select').forEach(select=>select.addEventListener('change',()=>{quiz.querySelector('[data-quiz-results]').hidden=true;}));
  quiz?.querySelector('[data-quiz-build]').addEventListener('click',()=>{
    const chosen=new Set();
    routine?.querySelectorAll('[data-routine-slot]').forEach(card=>{
      const slot=Number(card.dataset.routineSlot);
      const fits=p=>metadata[p.handle]?.slots.includes(slot)&&!chosen.has(p.id);
      const product=quizMatches.find(fits)||routineProducts.find(fits);
      if(product){chosen.add(product.id);const select=card.querySelector('[data-routine-product]');select.value=product.id;select.dispatchEvent(new Event('change',{bubbles:true}));card.querySelector('[data-routine-quantity]').value='1';}
    });
    updateRoutineTotal();routine?.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    routine?.querySelector('[data-routine-product]').focus({preventScroll:true});
  });
  document.querySelector('[data-review-filter]')?.addEventListener('change',event=>{
    document.querySelectorAll('[data-review]').forEach(review=>{review.hidden=event.target.value!=='all'&&review.dataset.review!==event.target.value;});
  });
  routine?.querySelector('[data-routine-add]')?.addEventListener('click', async (event) => {
    const button=event.currentTarget;
    const items = [...routine.querySelectorAll('[data-routine-slot]')].map(card=>({id:Number(card.querySelector('[data-routine-variant]').value),quantity:Number(card.querySelector('[data-routine-quantity]').value),properties:{_hushly_routine:'Build your night routine'}}));
    if (items.length !== 3 || items.some(i=>!i.id)) { toast('Choose all three routine products first.'); return; }
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Unable to add routine');
      const code = routine.dataset.discount;
      await window.hushlyCart.routine(code);
      button.disabled = false;
    } catch { toast('Your routine could not be added. Please try again.'); button.disabled = false; }
  });


})();

